var map = {
	"./bg.json": [
		961,
		0
	],
	"./cs.json": [
		962,
		1
	],
	"./da.json": [
		963,
		2
	],
	"./de.json": [
		964,
		3
	],
	"./el.json": [
		965,
		4
	],
	"./en.json": [
		966,
		5
	],
	"./es-AR.json": [
		967,
		6
	],
	"./es-ES.json": [
		968,
		7
	],
	"./fi.json": [
		969,
		8
	],
	"./fr.json": [
		970,
		9
	],
	"./hu.json": [
		971,
		10
	],
	"./it.json": [
		972,
		11
	],
	"./ja.json": [
		973,
		12
	],
	"./ko.json": [
		974,
		13
	],
	"./nb.json": [
		975,
		14
	],
	"./nl.json": [
		976,
		15
	],
	"./pl.json": [
		977,
		16
	],
	"./pt-BR.json": [
		978,
		17
	],
	"./pt-PT.json": [
		979,
		18
	],
	"./ro.json": [
		980,
		19
	],
	"./ru.json": [
		981,
		20
	],
	"./sl.json": [
		982,
		21
	],
	"./sv.json": [
		983,
		22
	],
	"./ta.json": [
		984,
		23
	],
	"./th.json": [
		985,
		24
	],
	"./tr.json": [
		986,
		25
	],
	"./zh-CN.json": [
		987,
		26
	],
	"./zh-TW.json": [
		988,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 954;
module.exports = webpackAsyncContext;